<template>
  <div class="log">
    <div class="messages" ref="messages">
      <span v-if="messages.length == 0" class="empty">
        &lt;empty message log&gt;
      </span>
      <span v-if="messages_purged" class="empty">
        &lt;messages truncated&gt;
      </span>

      <LogMessage
        v-for="(msg,idx) in filtered_messages" :key="idx + '-' + msg.timestamp.getTime()"
        :msg="msg" :show-times="show_times" v-on:setScrollHeight="scrollToBottom"
      ></LogMessage>

    </div> <!-- messages -->

    <div class="settings small">
      <div class="row">
        <Toggle label="Show from self" :default="true" @update="show_incoming_self = $event"></Toggle>
        <Toggle label="Show timestamps" :default="false" @update="show_times = $event"></Toggle>
        <Toggle label="Autoscroll" :default="true" @update="autoscroll = $event"></Toggle>
      </div>
      <div class="row">
        <FilterBox label="Filter by room" @update="filters.channel = $event"></FilterBox>
        <FilterBox label="Filter by sender/subject" @update="filters.sender = $event"></FilterBox>
        <FilterBox label="Filter by msg type" @update="filters.type = $event"></FilterBox>
        <!-- <FilterBox label="Filter by direction" @update="filters.direction = $event"></FilterBox> -->
      </div>
    </div>

  </div><!-- /log -->
</template>

<script>

import { EventBus } from '../EventBus.js';
import LogMessage from './LogMessage.vue';
import Toggle from './Toggle.vue';
import FilterBox from './FilterBox.vue';
const dayjs = require('dayjs');

export default {
  data () {
    return {
      messages: [],
      levels: [
        { code: 'e', name: 'error' },
        { code: 'w', name: 'warn' },
        { code: 'i', name: 'info' },
        { code: 'v', name: 'verbose' },
        { code: 'd', name: 'debug' }
      ],
      max_level: 'd',

      max_messages: 500,

      autoscroll: true,
      show_times: false,
      messages_purged: false,
      show_incoming_self: true,

      mouse_in_messages: false,

      filters: {
        channel: '',
        sender: '',
        type: '',
        direction: ''
      }
    };
  },
  components: {
    LogMessage,
    Toggle,
    FilterBox
  },
  methods: {
    scrollToBottom () {
      if (!this.execute_autoscroll) return;

      this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight + 500;
    },
    getLevelName (level) {
      return this.levels.filter((lvl) => {
        return lvl.code === level;
      })[0].name;
    },
    log (obj) {
      /*
      give it this object:
      {
        level: 'warn',
        channel: 'broadcast',
        sender: 'ws client name',
        type: 'message type,
        meta: <anything>,
        message: 'string memo if wanted'
      }
      */

      obj.timestamp = new Date();
      obj.time_fmt = dayjs(obj.timestamp).format('hh:mm:ssa');

      // allow shorthand log levels
      if (obj.level.length === 1) {
        obj.level = this.getLevelName(obj.level);
      }

      if (obj.sender === this.$store.state.ws_ticket.client) {
        obj.sender = 'self';
      }

      // if meta is string, we can output it as a message too
      if (!obj.message && typeof obj.meta === 'string') {
        obj.message = obj.meta;
      }

      this.messages.push(obj);

      if (this.messages.length > this.max_messages) {
        this.messages.shift();
        this.messages_purged = true;
      }
    }
  },
  computed: {
    execute_autoscroll () {
      return this.autoscroll && !this.mouse_in_messages;
    },
    filtered_messages () {
      return this.messages.filter((msg) => {
        let pass = true;

        if (!this.show_incoming_self) {
          pass = msg.sender !== 'self';
        }

        if (this.filters.channel) {
          pass = pass && (msg.channel && msg.channel.indexOf(this.filters.channel) === 0);
        }

        if (this.filters.sender) {
          pass = pass && (msg.sender && msg.sender.indexOf(this.filters.sender) === 0);
        }

        if (this.filters.type) {
          pass = pass && (msg.type && msg.type.indexOf(this.filters.type) === 0);
        }

        if (this.filters.direction) {
          pass = pass && (msg.direction && msg.direction.indexOf(this.filters.direction) === 0);
        }

        return pass;
      });
    },
    max_level_idx () {
      for (let i = 0; i < this.levels.length; i++) {
        if (this.levels[i].code === this.max_level) return i;
      }

      return -1;
    }
  },
  created () {
    // generic logs that aren't necessarily from websocket comms
    EventBus.$on('log', this.log);

    // log incoming websocket message (that's not from the logs room)
    EventBus.$on('incoming msg', (obj) => {
      obj.direction = '<-';
      this.log(obj);
    });

    // log outgoing websocket message
    EventBus.$on('outgoing msg', (obj) => {
      obj.direction = '->';
      this.log(obj);
    });
  },
  mounted () {
    // if mouse enters messages box, pause autoscroll
    this.$refs.messages.addEventListener('mouseenter', () => {
      this.mouse_in_messages = true;
    });
    this.$refs.messages.addEventListener('mouseleave', () => {
      this.mouse_in_messages = false;
    });
  }
};
</script>

<style lang="scss" scoped>
  .log {
    background-color: #c9c7cc;;
    font-family: 'Roboto Mono', monospace;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .messages {
    flex-grow: 1;
    padding: 50px 0 0 0;
    overflow-y: auto;
    display:block;

    &::after{
      content: "";
      height: 50px;
      display: block;
    }
  }

  .settings {
    //background-color: black;
    flex-shrink: 0;
    border-top: 1px solid #aaa;
    font-family: 'Roboto';
    padding: 50px 50px;

    .row {
      display: flex;
      flex-direction: row;
    }
  }

  .empty {
    opacity: 0.25;
    padding-left: 50px;
    margin-bottom: 10px;
    display: inline-block;
  }
</style>
